<!-- 报价单列表 -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" @click="addNew(0)" v-if="permission.addOrder"
                    >{{ permission.addOrder }} (F1)</el-button
                >
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="showSearchDialog">查询 (F2)</el-button>
                <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" @click="add(3)" v-if="permission.add">{{ permission.add }} (F3)</el-button>
                <el-button size="small" icon="el-icon-printer" class="search-btn btn-primary" id="printbj" @click="print()" v-if="permission.print">{{
                    permission.print
                }}</el-button>
                <el-button v-if="permission.printEng" size="small" icon="el-icon-printer" class="search-btn btn-primary" @click="printEng()">{{
                    permission.printEng
                }}</el-button>
                <el-button size="small" icon="el-icon-download" class="search-btn btn-primary" @click="exportForm()" v-if="permission.export">{{
                    permission.export
                }}</el-button>
                <el-button v-if="permission.exportEng" size="small" icon="el-icon-download" class="search-btn btn-primary" @click="exportEngForm">
                    {{ permission.exportEng }}
                </el-button>
                <el-button v-if="permission.importBJOrder" size="small" class="search-btn btn-primary" @click="gotoImportPage">
                    <i class="fa fa-file-excel-o"></i>
                    {{ permission.importBJOrder }}
                </el-button>
                <el-button size="small" icon="el-icon-document" class="search-btn btn-primary" @click="history()" v-if="permission.history">{{
                    permission.history
                }}</el-button>
                <el-button size="small" class="search-btn btn-primary" @click="showSearch()" v-if="permission.searchAP">{{ permission.searchAP }}</el-button>
                <el-button size="small" icon="el-icon-share" class="search-btn btn-primary" @click="shareQuote()" v-if="permission.shareQuote">{{
                    permission.shareQuote
                }}</el-button>
            </div>
        </div>
        <div class="table-ctn quote-order-table">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                :data="tableData"
                ref="multipleTable"
                @selection-change="handleSelectionChange"
                border=""
                style="width: 100%"
                @cell-dblclick="handleDBClick"
                v-loading="loading"
                :summary-method="getSummaries"
                show-summary
                :tableCode="tableCode"
                @sort-change="sortChange"
                :row-key="getRowKeys"
            >
                <el-table-column type="selection" reserve-selection width="50"></el-table-column>
                <template v-for="(col, index) in columnShowSets">
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort ? 'custom' : false"
                        header-align
                        :prop="col.ColumnCode"
                        v-if="col.ColumnCode == 'QCode'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <el-badge :value="'打印' + scope.row.PrintedCount + '次'" class="mark" type="danger" v-if="scope.row.PrintedCount > 0">
                                {{ scope.row.QCode }}
                            </el-badge>
                            {{ scope.row.PrintedCount > 0 ? '' : scope.row.QCode }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort ? 'custom' : false"
                        header-align
                        :prop="col.ColumnCode"
                        show-overflow-tooltip
                        v-else
                    >
                    </el-table-column>
                </template>
                <el-table-column fixed="right" label="操作" :autoWidth="true" :isCanSet="true">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button
                                v-if="permission.edit && scope.row.IsCanUpdate && scope.row.Intention != 2"
                                title="编辑"
                                size="mini"
                                type="text"
                                @click="add(2, scope.row)"
                                >{{ permission.edit }}</el-button
                            >
                            <el-button
                                v-if="permission.editOrder && scope.row.IsCanUpdate && scope.row.Intention != 2"
                                title="编辑"
                                size="mini"
                                type="text"
                                @click="addNew(2, scope.row)"
                                >{{ permission.editOrder }}</el-button
                            >
                            <el-button
                                v-if="permission.trans && scope.row.IsCanTransform"
                                title="转为销售订单"
                                size="mini"
                                type="text"
                                @click="gotoSalesOrderEdit(scope.row)"
                                >{{ permission.trans }}</el-button
                            >
                            <el-button
                                v-if="permission.transN && scope.row.IsCanTransform"
                                title="转为销售订单"
                                size="mini"
                                type="text"
                                @click="gotoSalesOrderEditN(scope.row)"
                                >{{ permission.transN }}</el-button
                            >
                            <el-button
                                v-if="permission.copyOrder && scope.row.State <= 2"
                                :title="permission.copyOrder"
                                size="mini"
                                type="text"
                                @click="add(5, scope.row)"
                                >{{ permission.copyOrder }}</el-button
                            >
                            <el-button
                                v-if="permission.copyOrder_v3 && scope.row.State <= 2"
                                :title="permission.copyOrder_v3"
                                size="mini"
                                type="text"
                                @click="addNew(5, scope.row)"
                                >{{ permission.copyOrder_v3 }}</el-button
                            >
                            <el-button v-if="scope.row.Intention == 2" size="mini" type="text" style="color: #e6a23c" @click="seeNoIntentionReason(scope.row)"
                                >无购买意向</el-button
                            >
                            <!-- 未转为销售订单的都可以删除 -->
                            <el-button
                                v-if="permission.del && scope.row.IsCanUpdate"
                                title="删除"
                                size="mini"
                                type="text"
                                style="color: red"
                                @click="delQuotationOrder(scope.row.QuoteId)"
                                >{{ permission.del }}</el-button
                            >
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
                v-if="tableDataLength != 0"
            ></el-pagination>
        </div>
        <el-dialog :close-on-click-modal="false" title="打印" :visible.sync="dialogVisible" width="840px">
            <div class="dialog-content" v-if="dialogVisible">
                <printBJContent @closeDialog="closeDialog" :printIds="idList" :isInit="true"></printBJContent>
            </div>
        </el-dialog>
        <!--  打印英文版  -->
        <el-dialog :close-on-click-modal="false" title="打印英报价单" :visible.sync="dialogPrintEngVisible" width="870px">
            <div class="dialog-content" v-if="dialogPrintEngVisible">
                <printEngContent @closeDialog="closePrintEngDialog" :printIds="idList"></printEngContent>
            </div>
        </el-dialog>
        <!--   搜索配件    -->
        <el-dialog :close-on-click-modal="false" title="搜索配件" :visible.sync="searchVisible" width="1200px">
            <div v-if="searchVisible">
                <searchAP Source="0" canEdit="canNot" @closeDialog="closeSearchDialog"></searchAP>
            </div>
        </el-dialog>
        <!--   分享报价    -->
        <el-dialog :close-on-click-modal="false" title="分享报价单明细" :visible.sync="shareQuoteVisible" width="500px">
            <div class="dialog-content" v-if="shareQuoteVisible">
                <div style="text-align: center; margin: 20px 0">
                    <img :src="QRImg" v-if="QRImg" />
                </div>
                <div style="text-align: center; margin: 30px 0 50px 0">
                    <p>
                        <i class="el-icon-download downExt" @click="downloadImg"></i>
                        截图或下载图片分享给客户，查看报价明细
                    </p>
                </div>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="报价单据搜索"
            :visible.sync="dialogSearchVisible"
            width="400px"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="search-quotation-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
        >
            <div class="dialog-content" v-if="dialogSearchVisible">
                <el-form ref="form" label-position="left" label-width="70px">
                    <el-form-item label="客户名称">
                        <el-select
                            ref="search_cus"
                            style="width: 100%"
                            size="small"
                            v-model="searchData.Keyword"
                            remote
                            filterable
                            allow-create
                            placeholder="客户名称/电话"
                            :remote-method="searchCustom"
                            v-select-scroll-more="searchCustomLoad"
                        >
                            <el-option v-for="item in cusOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName">
                                <div class="name">
                                    {{ item.EntpCusName }}
                                    <span v-if="item.CallNum" class="phone">{{ ` ( 电话：${item.CallNum} )` }}</span>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="报价单号">
                        <el-input size="small" v-model.trim="searchData.QCode" v-filter-special-char="searchData.QCode" placeholder="报价单号"></el-input>
                    </el-form-item>
                    <el-form-item label="订单状态" v-if="isExObj('StateName')">
                        <el-select style="width: 100%" size="small" v-model="searchData.State">
                            <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="来源" v-if="isExObj('CreatorType')">
                        <el-select style="width: 100%" size="small" v-model="searchData.Source">
                            <el-option v-for="item in sourceList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="询价日期" v-if="isExObj('ITime')">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="datetime3"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate3TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="报价日期" v-if="isExObj('QTime')">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="datetime"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDateTimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="创建日期" v-if="isExObj('CreateTime')">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="datetime1"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate1TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="更新日期" v-if="isExObj('UpdateTime')">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="datetime2"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate2TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                    <el-button size="small" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                    <el-button size="small" @click="closeSearchDialog_N">关闭（Esc）</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Vue from 'vue';
import elTableColumn from '@/components/common/chjtablecolumn';
import mixin from '@/mixins/mixin';
import printEngContent from '@/components/business/salesManage/printQuotationEng';
import searchAP from '@/components/common/searchAP';
import breadcrumb from '@/components/common/breadcrumb';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: 'bjManage',
    components: {
        searchAP,
        printEngContent,
        breadcrumb,
        elTableColumn
    },
    data() {
        return {
            tableCode: 'BJOrderTable',
            dialogPrintEngVisible: false,
            idList: [],
            startDateOps: {
                disabledDate: time => {
                    if (this.searchData.EndDate != '') {
                        return time.getTime() > new Date(this.searchData.EndDate);
                    }
                }
            },
            endDateOps: {
                disabledDate: time => {
                    if (this.searchData.StartDate != '') {
                        return time.getTime() <= new Date(this.$util.getOtherDay(this.searchData.StartDate, -1));
                    }
                }
            },
            stateList: [
                { Text: '全部', Value: '' },
                { Text: '未报价', Value: '0' },
                { Text: '已报价', Value: '1' },
                { Text: '已转为订单', Value: '2' }
            ],
            sourceList: [
                { Text: '全部', Value: '' },
                { Text: '内部创建', Value: '0' },
                { Text: '客户创建', Value: '1' },
                { Text: '车回佳', Value: '2' }
            ],
            searchVisible: false,
            dialogVisible: false,
            searchData: {
                Keyword: '',
                State: '',
                Source: '',
                QCode: '',
                StartDate: '',
                EndDate: '',
                UStartDate: '',
                UEndDate: '',
                QStartDate: '',
                QEndDate: '',
                IStartDate: '',
                IEndDate: '',
                SortProp: '',
                SortType: '',
                page: 1,
                limit: 15
            },
            tableData: [],
            tableDataLength: 0,
            permission: {},
            QRImg: '',
            shareQuoteVisible: false,
            // 用于客户名称列表，分页搜索
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            isStartSearch: false,
            datetime: [],
            datetime1: [],
            datetime2: [],
            datetime3: [],
            dialogSearchVisible: false,
            columnShowSets: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            isBPriceShow: false,
            loading: false,
            isStopReq: false
        };
    },
    watch: {
        isStartSearch(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    this.$refs.search_cus.focus();
                });
            }
        }
    },
    activated() {
        if (this.$store.state.needRefresh) {
            this.$store.commit('updateNeedRefresh', false);
            this.getTableData();
        }
        document.addEventListener('keydown', this.handleKeyEvent);
        //切换页面的时候不会清除当前页面缓存，但是其他页面也有相同字段，会串页面数据，还是把数据清空了不要误导
        this.$refs.multipleTable.clearSelection();
        this.idList = [];
        this.multipleSelection = null;
        //因为开启了keepalive的原因，所以要在这里重新加载打印模板，不然会调用其它页面的打印模板
        //this.getPrintComponents();
    },
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        if (this.dialogSearchVisible) this.dialogSearchVisible = false;
        next();
    },
    created() {
        if (this.tableCode) this.getSetsData();
        this.getConfigByCodes();
    },
    mounted() {
        let that = this;
        that.permission = that.$util.getPermission('bjManage');
        that.getPrintComponents();
    },
    methods: {
        handleKeyEvent(e) {
            let that = this;
            let key = window.event.keyCode;
            if (that.dialogVisible || that.dialogPrintEngVisible || that.searchVisible || that.shareQuoteVisible) {
                return;
            }
            //F1
            if (key === 112) {
                e.preventDefault();
                that.addNew(0);
                return;
            }
            //F2
            if (key === 113) {
                e.preventDefault();
                that.dialogSearchVisible = true;
                that.isStartSearch = true;
                return;
            }
            //F3
            if (key === 114) {
                e.preventDefault();
                that.add(3);
                return;
            }
            if (key === 13) {
                e.preventDefault();
                if (that.dialogSearchVisible) {
                    that.handleSearch();
                } else {
                    that.resetSearch();
                    that.getTableData();
                }
                that.isStartSearch = false;
                return;
            }
            if (key === 27) {
                if (that.dialogSearchVisible) {
                    e.preventDefault();
                    that.dialogSearchVisible = false;
                    that.isStartSearch = false;
                }
                return;
            }
            //右键
            if (key === 39) {
                e.preventDefault();
                if (!this.dialogSearchVisible) {
                    let page = that.searchData.page;
                    let limit = that.searchData.limit;
                    let totalPages = Math.ceil(that.tableDataLength / limit);
                    if (page < totalPages) {
                        that.searchData.page += 1;
                        that.getTableData();
                    }
                }
                return;
            }
            //左键
            if (key === 37) {
                e.preventDefault();
                if (!that.dialogSearchVisible) {
                    if (that.searchData.page !== 1) {
                        that.searchData.page -= 1;
                        that.getTableData();
                    }
                }
                return;
            }
        },
        getPrintComponents() {
            let that = this;
            that.$util.getPrintComponents('7').then(data => {
                if (data) {
                    Vue.component('printBJContent', () => import('@/components/printModels/' + data));
                } else {
                    Vue.component('printBJContent', () => import('@/components/printModels/printQuoted'));
                }
            });
        },
        getConfigByCodes() {
            let that = this;
            let codes = ['djmrdtsj', 'xskdxskdj'];
            let isDefaultToday = false;
            this.$util.getSysConfigs(codes).then(data => {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let code = data[i].Code;
                        let result = data[i].Result;
                        switch (code) {
                            case 'djmrdtsj':
                                isDefaultToday = result;
                                break;
                            case 'xskdxskdj':
                                this.isBPriceShow = result;
                                break;
                        }
                    }
                    if (isDefaultToday) {
                        //当前设定的日期时间
                        let d = new Date();
                        let year1, month1, day1;
                        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
                        let date1 = new Date(year1, month1, day1, 0);
                        that.datetime1.push(date1);

                        //前一天设定的日期时间
                        let year2, month2, day2;
                        d.setTime(d.getTime());
                        [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()];
                        let date2 = new Date(year2, month2, day2, 0);
                        that.datetime1.unshift(date2);

                        that.searchData.StartDate = date2;
                        that.searchData.EndDate = date1;
                    }
                }
                that.getTableData();
            });
        },
        // 客户名称列表，搜索
        async searchCustom(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            const data = await this.$util.searchCustomer(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustom();
        },
        showSearch() {
            this.searchVisible = true;
        },
        closeSearchDialog() {
            this.searchVisible = false;
        },
        gotoSalesOrderEdit(item) {
            let id = item ? item.QuoteId : '';
            this.$router.push(`/salesManage/quotation/transToSalesOrder?type=4&id=${id}`);
        },
        gotoSalesOrderEditN(item) {
            let id = item ? item.QuoteId : '';
            this.$router.push(`/salesManage/quotation/transToSalesOrder_v3?type=4&id=${id}`);
        },
        delQuotationOrder(id) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要删除报价单吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: `/api/EntpQuotationOrder/DelQuotationOrder?QuoteId=${id}`
                        })
                        .then(() => {
                            that.$util.successMsg('删除成功');
                            that.getTableData();
                        });
                }
            });
        },
        // 导出
        exportForm() {
            if (!this.idList[0]) {
                this.$util.warningMsg('请至少选择一条数据导出');
                return;
            }
            let QuoteIds = this.idList.join(',');
            this.$util.exportFile({
                url: '/api/EntpQuotationOrder/ExportQuotationOrder',
                data: {
                    QuoteIds: QuoteIds
                }
            });
        },
        exportEngForm() {
            if (!this.idList[0]) {
                this.$util.warningMsg('请至少选择一条数据导出');
                return;
            }
            let QuoteIds = this.idList.join(',');
            this.$util.exportFile({
                url: '/api/EntpQuotationOrder/ExportQuotationOrderEng',
                data: {
                    QuoteIds: QuoteIds
                }
            });
        },
        gotoImportPage() {
            this.$router.push('/salesManage/quotation/importOrdersExcel');
        },
        handleSelectionChange(val) {
            let idList = [];
            for (let i = 0; i < val.length; i++) {
                idList.push(val[i].QuoteId);
            }
            this.idList = idList;
        },
        closeDialog(isPrint) {
            this.dialogVisible = false;
            if (isPrint) {
                this.tableData.forEach(item => {
                    if (item.QuoteId == this.idList[0]) {
                        item.PrintedCount += 1;
                        return;
                    }
                });
                this.$refs.multipleTable.clearSelection();
            }
        },
        closePrintEngDialog(isPrint) {
            this.dialogPrintEngVisible = false;
            if (isPrint) {
                this.tableData.forEach(item => {
                    if (item.QuoteId == this.idList[0]) {
                        item.PrintedCount += 1;
                        return;
                    }
                });
                this.$refs.multipleTable.clearSelection();
            }
        },
        print() {
            if (this.idList.length != 1) {
                this.$util.warningMsg('请选择一张报价单打印');
                return;
            }
            this.dialogVisible = true;
        },
        // 打印英文版
        printEng() {
            if (this.idList.length != 1) {
                this.$util.warningMsg('请选择一张报价单打印');
                return;
            }
            this.dialogPrintEngVisible = true;
        },
        add(type, item) {
            let searchParams = this.searchData;
            // this.$util.setLocalStorage('bjManage_searchParams', searchParams); //保存当前查询参数，返回页面时使用

            let id = item ? item.QuoteId : '';
            this.$router.push(`/salesManage/quotation/edit_v2?type=${type}&id=${id}`);
        },
        addNew(type, item) {
            let searchParams = this.searchData;
            // this.$util.setLocalStorage('bjManage_searchParams', searchParams); //保存当前查询参数，返回页面时使用

            let id = item ? item.QuoteId : '';
            this.$router.push(`/salesManage/quotation/edit_v3?type=${type}&id=${id}`);
        },
        // 跳转历史配件报价
        history() {
            let searchParams = this.searchData;
            // this.$util.setLocalStorage('bjManage_searchParams', searchParams); //保存当前查询参数，返回页面时使用

            this.$router.push(`/salesManage/quotation/histories`);
        },
        resetSearch() {
            this.searchData = {
                State: '',
                Source: '',
                QCode: '',
                Keyword: '',
                StartDate: '',
                EndDate: '',
                UStartDate: '',
                UEndDate: '',
                QStartDate: '',
                QEndDate: '',
                IStartDate: '',
                IEndDate: '',
                SortProp: '',
                SortType: '',
                page: 1,
                limit: this.commonPageSize
            };
            this.datetime = [];
            this.datetime1 = [];
            this.datetime2 = [];
            this.datetime3 = [];
            // this.searchCustom('');
        },
        getTableData() {
            if (!this.isStopReq) {
                this.loading = true;
                this.isStopReq = true;
                this.$util
                    .axiosGet({
                        url: '/api/EntpQuotationOrder/GetEntpCusQuoteOrderList',
                        data: this.searchData,
                        hideLoading: true
                    })
                    .then(res => {
                        let data = res.data;
                        if (!data) data = [];
                        this.tableData = data;
                        if (this.searchData.page == 1) {
                            this.tableDataLength = res.count;
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                        this.isStopReq = false;
                    });
            }
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        handleDBClick(event) {
            if (event) {
                if (!this.permission.editOrder) this.add(1, event);
                else this.addNew(1, event);
            }
        },
        seeNoIntentionReason(item) {
            this.$alert(item.NoIntentionReason, '无购买意向原因', {
                confirmButtonText: '确定',
                callback: action => {}
            });
        },
        shareQuote() {
            let that = this;
            if (that.idList.length != 1) {
                that.$util.warningMsg('请选择一张报价单');
                return;
            }
            let orderData = that.tableData.find(e => e.QuoteId == that.idList[0]);
            if (!orderData) {
                that.$util.warningMsg('请选择一张报价单');
                return;
            }
            that.$util
                .axiosGet({
                    url: '/api/EntpQuotationOrder/GetQuotePageWxaCode',
                    data: {
                        qCode: orderData.QCode
                    }
                })
                .then(response => {
                    let data = response.data;
                    if (data) {
                        that.QRImg = 'data:image/png;base64,' + response.data;
                        that.shareQuoteVisible = true;
                    } else {
                        that.$util.warningMsg('请检查是否按要求操作，确认后重新提交');
                    }
                })
                .catch(() => {});
        },
        downloadImg() {
            let that = this;
            let blob = that.$util.dataURLtoBlob(that.QRImg);
            const elink = document.createElement('a');
            // 设置下载文件名
            let orderData = that.tableData.find(e => e.QuoteId == that.idList[0]);
            // const timedate = Date.parse(new Date())
            let qCode = orderData.QCode;
            elink.download = `报价单二维码${qCode}.png`;
            elink.style.display = 'none';
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            document.body.removeChild(elink);
        },
        showSearchDialog() {
            this.dialogSearchVisible = true;
            this.isStartSearch = true;
        },
        closeSearchDialog_N() {
            this.dialogSearchVisible = false;
            this.isStartSearch = false;
            // this.resetSearch();
        },
        onDateTimeSelect(val) {
            if (val != null) {
                this.searchData.QStartDate = val[0];
                this.searchData.QEndDate = val[1];
            } else {
                this.searchData.QStartDate = '';
                this.searchData.QEndDate = '';
            }
        },
        //选中时间
        onDate1TimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        onDate2TimeSelect(val) {
            if (val != null) {
                this.searchData.UStartDate = val[0];
                this.searchData.UEndDate = val[1];
            } else {
                this.searchData.UStartDate = '';
                this.searchData.UEndDate = '';
            }
        },
        onDate3TimeSelect(val) {
            if (val != null) {
                this.searchData.IStartDate = val[0];
                this.searchData.IEndDate = val[1];
            } else {
                this.searchData.IStartDate = '';
                this.searchData.IEndDate = '';
            }
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.getTableData();
        },
        isExObj(str) {
            let index = this.columnShowSets.findIndex(item => item.ColumnCode === str);
            return index > -1;
        },
        getSetsData() {
            this.columnShowSets = [];
            this.$util.getTBSetsForShow(this.tableCode).then(data => {
                data.forEach(item => {
                    let colums = {
                        IsShow: item.IsShow,
                        Width: item.Width,
                        ColumnName: item.ColumnName,
                        ColumnCode: item.ColumnCode,
                        SortNum: item.SortNum,
                        IsSort: item.IsSort
                    };

                    this.columnShowSets.push(colums);
                });
            });
        },
        // 记录每行的key值
        getRowKeys(row) {
            return row.QuoteId;
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                if (
                    column.property == 'NeedTime' ||
                    column.property == 'Creator' ||
                    column.property == 'CallNum' ||
                    column.property == 'Remark' ||
                    column.property == 'UpdateTime' ||
                    column.property == 'CreateTime'
                ) {
                    sums[index] = '';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    let strL = sums[index] + '';
                    if (strL.indexOf('.') > -1) {
                        let str = strL.split('.')[1];
                        if (str.length > 2) {
                            sums[index] = sums[index].toFixed(2);
                        }
                    }
                } else {
                    sums[index] = '';
                }
            });

            return sums;
        }
    }
};
</script>
<style lang="less" scoped>
#search-quotation-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .search-item-dialog {
        width: 340px;
        height: auto;
        .dialog-footer {
            text-align: right;
        }
        .el-form-item {
            margin-bottom: 0;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
</style>
<style lang="less">
.el-table::before {
    z-index: inherit !important;
}
.downExt {
    font-size: 24px;
    font-weight: 900;
    padding-right: 5px;
    cursor: pointer;
}
.quote-order-table {
    .el-table__row {
        td:nth-child(2) {
            .cell {
                overflow: visible;
            }
        }
    }
}
</style>
